import React, { useState } from "react";

import BuyButton from "./BuyButton";
import SuccessButton from "./SuccessButton";

interface ButtonPropsI {
	message: string;
	bought: string;
	className?: string;
	tabIndex?: number | undefined;
	onClick: () => void;
}

const Button = (props: ButtonPropsI) => {
	const [isLoading, toggleIsLoading] = useState(false);
	const [isSuccess, toggleIsSuccess] = useState(false);

	const onClickHandler = () => {
		props.onClick();

		if (!isLoading) {
			toggleIsLoading(true);
			setTimeout(() => {
				toggleIsLoading(false);
				toggleIsSuccess(true);
			}, 100);
		}
	};

	const { message, bought, tabIndex, className } = props;
	const label = isSuccess || isLoading ? bought : message;

	return (
		<span aria-live="polite" className="addtocart-buttonContainer">
			{isSuccess || isLoading ? (
				<SuccessButton
					className={className}
					bought={bought}
					label={label}
					onClickHandler={onClickHandler}
					tabIndex={tabIndex}
				/>
			) : (
				<BuyButton
					className={className}
					label={label}
					onClickHandler={onClickHandler}
					tabIndex={tabIndex}
				/>
			)}
		</span>
	);
};

export default Button;
